import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {toTopicPayload} from '../../lib/types/generic-payload'

import {Box, Grid, Heading, CheckboxGroup, FormControl, Checkbox} from '@primer/react-brand'

export function TopicPage() {
  const {title = 'Artificial Intelligence', topics} = toTopicPayload(useRoutePayload<unknown>())

  return (
    <Box>
      <Grid>
        <Grid.Column span={12}>
          <Box marginBlockStart={{narrow: 64, regular: 112}} marginBlockEnd={{regular: 64}}>
            <Heading as="h1">{title}</Heading>
          </Box>
        </Grid.Column>
        <Grid.Column span={{xsmall: 12, medium: 3}}>
          <aside>
            <hr />
            <CheckboxGroup>
              <CheckboxGroup.Label>TOPIC</CheckboxGroup.Label>
              {topics.map(topic => (
                <FormControl key={topic.id}>
                  <Checkbox value={topic.id} name="topic" />
                  <FormControl.Label>{topic.preferred_label}</FormControl.Label>
                </FormControl>
              ))}
            </CheckboxGroup>
          </aside>
        </Grid.Column>
        <Grid.Column span={{xsmall: 12, medium: 9}}>
          <p>Content for the selected topic will go here.</p>
        </Grid.Column>
      </Grid>
    </Box>
  )
}

try{ TopicPage.displayName ||= 'TopicPage' } catch {}